import { NgClass } from "@angular/common";
import { Component, ElementRef, Input, ViewChild } from "@angular/core";
import { SvgIconComponent } from "@ponder-shared/components/svg-icon.component";
import { SvgIcon } from "@ponder-shared/utils/svgIcons";
import { AdvancedSearchParameter, AdvancedSearchService } from "../advanced-search.service";
import { DropdownKeyValue, SearchableDropdownListComponent } from "@ponder-shared/components/searchable-dropdown-list.component";

@Component({
    selector: "advanced-search-multi-list",
    imports: [NgClass, SvgIconComponent, SearchableDropdownListComponent],
    templateUrl: "./advanced-search-multi-list.component.html"
})
export class AdvancedSearchMultiListComponent {
    @Input({ required: true }) public type!: AdvancedSearchParameter;
    @Input({ required: true }) public keys: string[] = [];
    @Input({ required: true }) public values: string[] = [];

    @Input() public allowAnd: boolean = true;
    public logicalAnd: boolean = false;       // If false, then logical mode is OR. If true, then logical mode is AND.

    public hasValue: boolean = false;
    public closeSvgIcon: SvgIcon = SvgIcon.Close;
    public selectedItems: DropdownKeyValue[] = [];
    
    public constructor(private advancedSearch: AdvancedSearchService) {
        
    }

    public ngOnInit(): void {
        
    }

    public canSelect(): boolean {
        // Limit to 5 selected items to match backend restrictions.
        return this.selectedItems.length < 5;
    }

    public onChange(kvp: DropdownKeyValue): void {
        const index = this.selectedItems.findIndex(i => i.value == kvp.value);

        if (index >= 0) {
            this.selectedItems.splice(index, 1);
        } else {
            this.selectedItems.push(kvp);
            this.hasValue = true;
        }

        if (this.selectedItems.length == 0) {
            this.onClear();
        } else {
            this.passParameters();
        }
    }

    public onDeselectItem(kvp: DropdownKeyValue): void {
        const index = this.selectedItems.findIndex(i => i.value == kvp.value);

        if (index >= 0) {
            this.selectedItems.splice(index, 1);
        }

        if (this.selectedItems.length == 0) {
            this.onClear();
        } else {
            this.passParameters();
        }
    }

    public onClear(): void {
        this.selectedItems = [];
        this.hasValue = false;
        this.passParameters();
    }

    public onToggleLogicalMode(): void {
        this.logicalAnd = !this.logicalAnd;
        this.passParameters();
    }

    private passParameters(): void {
        this.advancedSearch.setArray(this.type, this.logicalAnd, this.selectedItems.map(kvp => kvp.value));
    }
}